import { useEffect, useRef } from "react"

import { logout, userSessionStore, useUserInfo } from "~/domain/user-session"
import { apiUrlPrefix } from "~/shared/config"

function createEventSource(eventSourceRef: { current: EventSource | null }) {
	eventSourceRef.current = new EventSource(`${apiUrlPrefix}/sse`, {
		withCredentials: true
	})

	eventSourceRef.current.onmessage = (e) => {

		switch (e.data) {
			case "client_created":
				console.log("Подключение к Server Sent Events")
				break
			case "logout":
				void (logout())
				break
		}
	}

	eventSourceRef.current.onerror = (e) => {
		eventSourceRef.current = null
		console.log("Не удалось подключиться к Server Sent Events", e)

		setTimeout(async () => {

			// При включении VPN соединение SSE обрубается
			if ((await userSessionStore.checkIfIpWasChanged())) {
				location.reload()
				return
			}

			if(!userSessionStore.userInfo) return

			// В SSE нельзя определить из-за чего возникла ошибка, поэтому, на всякий случай, обновим токен
			const result = await userSessionStore.refreshToken()

			if(!result) return

			createEventSource(eventSourceRef)
		}, 3000)
	}
}

export function SSE() {

	const userInfo = useUserInfo()
	const eventSourceRef = useRef<EventSource | null>(null)

	useEffect(() => {

		const { resolve, promise } = Promise.withResolvers<void>()

		if (userInfo) {
			if (navigator.locks) {
				void navigator.locks.request("sse", async () => {
					createEventSource(eventSourceRef)
					await promise
				})
			} else {
				createEventSource(eventSourceRef)
			}
		}

		const onBeforeUnload = () => {
			resolve()
		}

		window.addEventListener("beforeunload", onBeforeUnload)

		return () => {
			resolve()
			eventSourceRef.current?.close()
			eventSourceRef.current = null
			window.removeEventListener("beforeunload", onBeforeUnload)
		}

	}, [userInfo])

	return null
}